<template>
  <el-form class="volumes add-prof-job add-prof-job-user-tabel">
    <el-dialog :title="`Выбрать работника`"
               @close="closeDialog"
               v-loading="loading"
               :visible.sync="isSelect" append-to-body
               width="480px">
      <div style="display: flex; margin-bottom: 10px">
        <el-switch @change="allSelect" v-model="isAllUser"></el-switch>
        <strong style="margin-left: 4px">Все работники</strong>
      </div>
      <div>
        <filter-select
          hideLabel
          style="margin-bottom: 5px"
          multiple
          noTag
          @addNew="addNew"
          :add-new-enable="!!companyData.enableCreateUser"
          v-model="selectUsers"
          placeholder="Работник"
          :options="filterUsers"
        />
      </div>

      <div style="display: flex">
        <el-input type="number" placeholder="Часы" v-model="formSelect.time" style="margin-right: 5px"></el-input>
        <el-input placeholder="Код" v-model="formSelect.code" style="margin-left: 5px"></el-input>
      </div>

      <el-form-item label="Комментарий">
        <el-input type="textarea" v-model="formSelect.comment"></el-input>
      </el-form-item>

      <div style="display: flex; justify-content: flex-end; margin-top: 10px; padding-bottom: 10px">
        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          @click="close">Отменить
        </el-button>
        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          @click="add"
          type="primary">Сохранить
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      @close="closeModalAll"
      append-to-body width="440px" :visible.sync="isSelectMultiple"
      :title="`Применить к выбраным работникам:`">
      <div style="display: flex">
        <el-input placeholder="Часы" type="number" v-model="formSelectMultiple.time" style="margin-right: 5px"></el-input>
        <el-input placeholder="Код" v-model="formSelectMultiple.code" style="margin-left: 5px"></el-input>
      </div>

      <el-form-item label="Комментарий">
        <el-input type="textarea" v-model="formSelectMultiple.comment"></el-input>
      </el-form-item>

      <el-checkbox v-model="addAllUser">Добавить всех работников</el-checkbox>

      <div style="display: flex; justify-content: flex-end; margin-top: 10px; padding-bottom: 10px">
        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          type="default" @click="closeMultiple">Отменить
        </el-button>
        <el-button @click="removeCheckbox" type="danger">Удалить</el-button>
        <el-button
          style="margin-left: 4px; padding: 12px 8px"
          @click="saveMultiple"
          type="primary">Сохранить
        </el-button>
      </div>
    </el-dialog>
    <div class="volumes">
      <div class="remove-row-container">
        <i class="el-icon-close" v-if="!approve" @click="removeReportClick"></i>
      </div>
      <div class="jobs-ul">

        <div style="display: flex; justify-content: space-between">
          <el-checkbox v-model="selectAll" @change="changeMultipleCheck" style="margin-right: 8px"></el-checkbox>
          <el-button :disabled="approve" size="small" class="add" type="primary"
                     style="width: 100%; margin-bottom: 10px"
                     @click="isSelectMultiple = !isSelectMultiple">
            Заполнить
          </el-button>
        </div>
        <div style="display: flex; justify-content: flex-start">
        </div>

        <div>
          <div v-for="(user, index) in form.jobs" :key="user.id + index" class="user-line-table">
            <div
              v-if="!search || (user.username || '' ).toLowerCase().includes(search.toLowerCase())"
              style="display: flex; justify-content: space-between; flex: 1; width: 100%">
              <div class="user-container">
                <div class="user-line"
                     :key="user.id + '-' + index">
                  <div class="user-section">
                    <el-checkbox v-model="user.isSelect" style="margin-right: 8px"></el-checkbox>
                    <span>{{ user.username }}</span>
                  </div>
                  <div class="user-input-section">
                    <el-input class="padding-input-4" size="small" style="width: 32px; margin-right: 8px"
                              v-model="user.time"></el-input>
                    <el-input class="padding-input-4" size="small" style="width: 32px" v-model="user.code"></el-input>
                  </div>
                </div>
              </div>

              <div class="flex align">
                <div>
                </div>
                <i class="el-icon-close" v-if="!approve" style="margin-left: 10px" @click="remove(index)"/>
              </div>
            </div>
          </div>
        </div>
        <el-button :disabled="approve" size="small" class="add" type="primary"
                   style="width: calc(100% - 22px); margin-bottom: 10px; margin-left: 22px"
                   @click="isSelect = !isSelect">
          + Выбрать работника
        </el-button>
        <div style="margin-top: 20px" class="add-prof-filter">
          <filter-select
            :disabled="approve"
            v-model="form.work_type_dir"
            @input="() => form.work_type = null"
            v-if="$store.state.project.work_dir"
            :options="options_dirs" label="Раздел работ" style="margin-bottom: 0;"
          />
          <filter-select
            :disabled="approve"
            @input="selectWorkType"
            v-if="!$store.state.project.work_type_ignore" label="Вид работы" style="margin-bottom: 28px; margin-top: 0"
            :options="getWorks(form.work_type_dir)"
            v-model="form.work_type"/>

        </div>
      </div>
    </div>
  </el-form>
</template>

<script>

import firebase from "firebase";
import {getCurrentMonth} from "../../../../utils/date";
import FilterSelect from "../../../../components/FilterSelect";
import {toFloat} from "../../../../utils/numberUtils";
import {getDirOptions} from "../../../../firestore/dirs";
import MultipleUser from "./MultipleUser.vue";
import _ from "lodash";
import {getChildList} from "../../../../utils/getChild";
import th from "vue2-datepicker/locale/es/th";

export default {
  name: "AddUserTabel",
  inject: ['timeProfGlobal'],
  components: {MultipleUser, FilterSelect},
  props: {
    search: String,
    approve: Boolean,
    value: {},
    mainForm: Object,
    workTypeOptions: {type: [Object, Array], default: () => ([])},
    jobName: "",
    users: Array,
    type: {
      type: String,
      default: 'PROF'
    },
  },
  data() {
    return {
      dialogObject: false,
      options_dirs: [],
      isSelect: false,
      loading: false,
      selectUsers: [],
      selectAll: false,
      addAllUser: false,
      lock: false,
      companyData: null,
      isAllUser: false,
      allUsersList: [],
      isSelectMultiple: false,
      list: [],
      form: {
        jobs: [],
        work_type: null,
        work_type_dir: null,
      },
      formSelectMultiple: {
        time: '',
        code: 'Я',
        comment: '',
      },
      formSelect: {
        time: '',
        code: 'Я',
        comment: '',
      },
      tr: {
        PROF: 'профессию',
        TECH: 'технику',
      },
      tra: {
        PROF: 'профессий',
        TECH: 'техники',
      },
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler(form) {
        if (!this.lock) {
          console.log(form, 'form')
          this.$emit('input', form)
        }
      }
    }
  },
  methods: {
    closeModalAll() {
      this.addAllUser = false
    },
    changeMultipleCheck(d) {
      this.form.jobs = this.form.jobs.map((job) => {
        job.isSelect = d
        return job
      })
    },
    async allSelect() {
      if (!this.allUsersList.length) {
        this.loading = true
        const users = await firebase.firestore()
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('users')
          .get()
        const result = []
        const usersT = []

        users.forEach((user) => {
          usersT.push({...user.data(), id: user.id})
        })
        for (const u of usersT) {
          if (u.is_one_report_table) {
            const usersData = await firebase.firestore()
              .collection('projects')
              .doc(this.$store.state.project.id)
              .collection('users')
              .doc(u.id)
              .collection('table')
              .get()


            usersData.forEach((s) => {
              result.push({...s.data(), id: s.id})
            })




          }
        }
        this.allUsersList =   _.orderBy(result, 'index', ['asc'])

        this.loading = false
      }
    },
    closeMultiple() {
      this.isSelectMultiple = false;
      this.formSelectMultiple = {
        time: this.timeProfGlobal.value,
        code: 'Я',
        comment: '',
      }

      this.addAllUser = false
    },
    close() {
      this.isSelect = false;
      this.formSelect = {
        time: this.timeProfGlobal.value,
        code: 'Я',
        comment: '',
      }
    },
    addAllUsers() {
      this.filterUsers.forEach((user) => {
        let job = this.list.find(({id}) => id === user.profId)


        if (!job) {
          job = this.list.find(({name}) => name === 'Рабочие')
        }

        if (!job._data) {
          job._data = {}
        }

        this.form.jobs.push({
          is_table: true,
          plan: job._data.plan || '',
          ...user,
          username: user.name || user.label,
          isSelect: true,
          ...job._data,
          value: 1,
          ...this.formSelect
        })
        console.log('kek')
      })

      this.form.jobs = [...this.form.jobs]
    },
    saveMultiple() {
      if (this.addAllUser) {
        this.addAllUsers()
      }

      this.form.jobs = this.form.jobs.map((f) => {
        if (f.isSelect) {
          f = {
            ...f,
            ...this.formSelectMultiple,
            isSelect: false,
          }
        }

        return f
      })

      this.formSelectMultiple = {
        time: '',
        code: '',
        comment: '',
      }


      this.isSelectMultiple = false
      this.selectAll = false
    },
    removeCheckbox() {
      this.form.jobs = this.form.jobs.filter((f) => !f.isSelect)
      this.isSelectMultiple = !this.isSelectMultiple
    },
    closeDialog() {
      setTimeout(() => {
        this.formSelect = {
          time: '',
          code: '',
          comment: '',
        }

        this.selectUsers = []

      }, 500)
    },
    async addNew(user) {
      this.companyData = this.mainForm.user._data || this.mainForm.user

      const addUser = await firebase.firestore()
        .collection('projects')
        .doc(this.$store.state.project.id)
        .collection('users')
        .doc(this.companyData.id)
        .collection('table').add({
          name: user,
          personnelNumber: "",
          profId: "",
          comment: "",
          hourRate: ""
        })

      this.$emit('new-user', {
        name: user,
        personnelNumber: "",
        profId: "",
        comment: "",
        hourRate: "",
        id: addUser.id,
      })

      this.selectUsers.push({
        name: user,
        label: user,
        value: addUser.id,
        personnelNumber: "",
        profId: "",
        comment: "",
        hourRate: "",
        id: addUser.id,
      })
      console.log(this.selectUsers, 'selectUsers')
      this.selectUsers = [...this.selectUsers]

      // this.allUsersList = [...this.allUsersList]
    },
    async removeReportClick() {
      this.$emit('remove', {
        structureObj: this.structureObj,
        editIndex: this.editIndex
      })

      this.dialogObject = false;
    },
    selectWorkType() {
      this.form.work_type_dir = this.form.work_type_dir || this.options_dirs.find(({value}) => (this.form.work_type && this.form.work_type.data && (this.form.work_type.data.dir === value)))

    },
    getWorks(id) {
      if (!id || !id.value) {
        return this.workTypeOptions
      }

      return this.workTypeOptions.filter(({data}) => data.dir === id.value);
    },
    add(job) {
      this.selectUsers.forEach((user) => {
        let job = this.list.find(({id}) => id === user.profId)


        if (!job) {
          job = this.list.find(({name}) => name === 'Рабочие')
        }

        if (!job._data) {
          job._data = {}
        }

        this.form.jobs.push({
          is_table: true,
          plan: job._data.plan || '',
          ...user,
          username: user.name || user.label,
          ...job._data,
          value: 1,
          ...this.formSelect
        })
      })
      this.isSelect = false;
    },
    removeAll() {
      this.form.jobs = []
    },
    save() {

      let work_type = null;

      if (this.form.work_type) {
        work_type = {
          label: this.form.work_type.label,
          value: this.form.work_type.value,
          work_code: this.form.work_type.data && this.form.work_type.data.work_code || null,
          dir: this.form.work_type.data.dir
        }
      }


      this.$emit('save', {
        jobs: [
          ...this.form.jobs.map((r) => {
            delete r.dataTotalValue
            delete r.ids_tech
            delete r.ids_prof
            delete r.project
            delete r.inputs
            delete r.volumes_prof
            delete r.permission
            delete r.volumes_tech
            delete r.volumes

            return r
          }),
        ],
        work_type: work_type,
        work_type_dir: this.form.work_type_dir,
        options_dirs: this.form.options_dirs,
        total: toFloat(this.total),
        value: toFloat(this.value1),
        time: toFloat(this.time)
      })

      this.dialogObject = false;
    },
    remove(index) {
      const result = [...this.form.jobs];
      result.splice(index, 1)
      this.form.jobs = [...result];
    }
  },
  async mounted() {
    this.form = JSON.parse(JSON.stringify(this.value));
    this.formSelect.time = this.timeProfGlobal.value
    this.formSelectMultiple.time = this.timeProfGlobal.value
    this.companyData = this.mainForm.user._data || this.mainForm.user

    firebase.firestore()
      .collection('projects')
      .doc(this.$store.state.project.id).collection('jobs')
      .where('type', '==', this.type).get()
      .then((data) => {
        const result = []
        data.forEach((subDoc) => {
          const data = subDoc.data()
          result.push({
            name: data.name,
            plan: data.plan,
            id: subDoc.id,
            _data: data
          })
        })


        this.list = result;
      });

    this.options_dirs = await getDirOptions(this.$store.state.project.id);
    // this.lock = false
    this.selectWorkType()
  },
  computed: {
    filterUsers() {
      if (!this.isAllUser) {
        return this.users.map((user) => {
          user.label = user.name;
          user.value = user.id;

          return user
        })
      } else {
        return this.allUsersList.map((user) => {
          user.label = user.name;
          user.value = user.id;

          return user
        })
      }
    },
    total() {
      let result = 0;

      this.form.jobs.forEach(({plan}) => {
        result += plan || 0
      })

      return result
    },
    value1() {
      let result = 0;

      this.form.jobs.forEach(({value}) => {
        result += Number(value || 0)
      })

      return result
    },
    time() {
      let result = 0;

      this.form.jobs.forEach(({time}) => {
        result += time || 0
      })

      return result
    },
    currentMonth() {
      return getCurrentMonth(this.$route.query.name)
    }
  }
}
</script>

<style scoped lang="scss">

.add-prof-job {
  width: calc(100% - 42px);
}


.add-prof-job-user-tabel {
  padding: 5px 2px !important;
  width: 100% !important;
  max-width: 100% !important;
  margin-left: 0 !important;
}

.fa-edit {
  font-size: 18px;
  width: 100px;
}

.volumes {
  max-width: 95%;
  margin-left: 8px;
}

.create-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
}

.jobs-ul {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 8px;
}

.jobs-li {
  justify-content: center;
  min-height: 36px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  text-align: left;
  align-items: flex-start;
  cursor: pointer;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);

  &.pick {
    padding-bottom: 8px !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.18);
    align-items: center;
  }

  &:hover {
    background: #eee;
  }

  &:last-child {
    border-bottom: none;
  }
}

.add-prof-job {
  padding: 5px 15px;
  margin-bottom: 10px;
  background: #f7f7f7;
  box-shadow: 0px 0px 8px 0px #ccc;
  border-radius: 5px;
}

.remove-row-container {
  display: flex;
  justify-content: flex-end;
  height: 32px;
  align-items: center;

  .el-icon-close {
    cursor: pointer;
    font-size: 20px;
  }
}
</style>
<style lang="scss">
.volumes .el-dialog {
  max-width: 100% !important;
}

input::placeholder {
  color: #888 !important;
}

.add-prof-filter {
  .el-form-item {
    margin-bottom: 4px;
  }
}

.user-container {
  width: 100%;
  display: flex;
  flex: 1;
}

.user-line {
  display: flex;
  width: 100%;
  justify-content: space-between;
  flex: 1;
  padding: 6px 0;
  align-items: center;
}

.user-line-table {
  border-bottom: 1px solid rgba(0, 0, 0, 0.18) !important;

  &:last-child {
    border-bottom: none !important;
  }
}

.user-section {
  display: flex;
  align-items: center;
  color: #0e1011;
  font-size: 16px;
  text-align: left;
  overflow: hidden;
  max-width: calc(100% - 85px);
  text-overflow: ellipsis;

}
</style>

<style lang="scss">
.padding-input-4 {
  input {
    padding: 0 4px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/ReportsOneComplete/components/AddUserTabel.vue